import React, { useState } from 'react';
import logo from './assest/hex_logo.png';
import NavBar from './navbar';
import SkinnyBanner_FaxNumber from './assest/SkinnyBanner_FaxNumber.png';
import WCHR_WebsiteHeader_1 from './assest/2020WCHR_WebsiteHeader_1.png';
import './App.css';
import TableRider from './component/rider';
import { Grid } from '@material-ui/core';
import SideMenuDefault from './sidemenu';
import FooterComp from './footer';
import { Hidden } from '@material-ui/core';

const Layout = React.lazy(() => import('./layout'));

function App() {
  const [search, setSearch] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleEnter = (e) => {
    if (e.code === 'Enter') {
      const url = `https://www.ushja.org/search?query=${search}`;
      window.open(url, '_self');
    }
  };

  return (
    <div>
      <div className='navbarheader'>
        <div className='secheader'>
          <div className='navbarhd-lt'>
            <a href='https://www.ushja.org/'>
              <img src={logo} />
            </a>
          </div>
          <div className='navbarhd-rt'>
            <nav className='navbar'>
              <div className='container-fluid p-0'>
                <ul className='nav navbar-nav navbar-link'>
                  <li className='active'>
                    <a href='https://ushja.org/about-us-and-news/sponsors-and-partners/sponsors'>
                      Our Sponsors
                    </a>
                  </li>
                  <li>
                    <a href='https://ushja.org/contact-us'>Contact Us</a>
                  </li>
                  <li>
                    <a href='https://ushja.org/about-us-and-news/our-missionhistory'>
                      About Us
                    </a>
                  </li>
                </ul>
                <ul className='nav navbar-nav navbar-icon searchblk'>
                  <li className=''>
                    <div className='input-group-btn'>
                      <button className='headericon searchicon' type='button'>
                        <i class='fa fa-search' aria-hidden='true'></i>
                      </button>
                    </div>
                    <div id='search_container'>
                      <input
                        type='text'
                        name='name'
                        placeholder='Search'
                        value={search}
                        onChange={(e) => handleSearch(e)}
                        onKeyPress={(e) => handleEnter(e)}
                      />
                    </div>
                  </li>
                </ul>
                <ul className='nav navbar-nav navbar-icon socmedicon'>
                  <li className=''>
                    <div className='input-group-btn'>
                      <a className='headericon' type=''>
                        <i
                          class='fa fa-facebook-square'
                          aria-hidden='true'
                          onClick={() => {
                            window.open(
                              'https://www.facebook.com/USHJA/',
                              '_window'
                            );
                          }}
                        ></i>
                      </a>
                    </div>
                  </li>
                  <li className=''>
                    <div className='input-group-btn'>
                      <a className='headericon' type=''>
                        <i
                          class='fa fa-twitter'
                          aria-hidden='true'
                          onClick={() => {
                            window.open('https://twitter.com/USHJA', '_window');
                          }}
                        ></i>
                      </a>
                    </div>
                  </li>
                  <li className=''>
                    <div className='input-group-btn'>
                      <a className='headericon' type=''>
                        <i
                          class='fa fa-instagram'
                          aria-hidden='true'
                          onClick={() => {
                            window.open(
                              'https://www.instagram.com/ushunterjumper',
                              '_window'
                            );
                          }}
                        ></i>
                      </a>
                    </div>
                  </li>
                </ul>
                <ul className='nav navbar-nav navbar-button'>
                  
                  <li>
                    <nav className='navbar hidden-lg show-xs'>
                      <div className='dropdown-submenu p-0'>
                        <div className='navbar-header'>
                          <button
                            type='button'
                            className='navbar-toggle mobilemenu-toggle'
                            data-toggle='modal'
                            data-target='#myModal'
                          >
                            MENU{' '}
                            {/* <i
                              className='fa fa-arrow-down'
                              aria-hidden='true'
                            ></i> */}
                            <div className='primaryheader mobilemenu'>
                              <NavBar />
                            </div>
                          </button>
                          <div
                            className='modal fade'
                            id='myModal'
                            role='dialog'
                            style={{ backgroundColor: '#000000a6' }}
                          >
                            <div className='modal-dialog'>
                              <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                              >
                                ×
                              </button>
                              {/* <!-- Modal content--> */}
                              <div className='dropdown mobilemenu'>
                                <ul className='mobilemenuwrap'>
                                  <li>
                                    <a
                                      className='btn btn-default dropdown-toggle'
                                      type='button'
                                      data-toggle='dropdown'
                                    >
                                      Tutorials
                                      <span className='caret'></span>
                                    </a>
                                    <ul className='dropdown-menu'>
                                      <li>
                                        <a tabindex='-1' href='#'>
                                          HTML
                                        </a>
                                        <i class='menu-arrow arrow-l2 fas fa-arrow-right'></i>
                                      </li>
                                      <li>
                                        <a tabindex='-1' href='#'>
                                          CSS
                                        </a>
                                      </li>
                                      <li className='dropdown-submenu'>
                                        <a
                                          className='test'
                                          tabindex='-1'
                                          href='#'
                                        >
                                          New dropdown{' '}
                                          <span className='caret'></span>
                                        </a>
                                        <ul className='dropdown-menu'>
                                          <li>
                                            <a tabindex='-1' href='#'>
                                              2nd level dropdown
                                            </a>
                                          </li>
                                          <li>
                                            <a tabindex='-1' href='#'>
                                              2nd level dropdown
                                            </a>
                                          </li>
                                          <li className='dropdown-submenu sublink'>
                                            <a className='sublink' href='#'>
                                              Another dropdown{' '}
                                              <span className='caret'></span>
                                            </a>
                                            <ul className='dropdown-menu'>
                                              <li>
                                                <a href='#'>
                                                  3rd level dropdown
                                                </a>
                                              </li>
                                              <li>
                                                <a href='#'>
                                                  3rd level dropdown
                                                </a>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                    <li>
                                      <a
                                        className='btn btn-default dropdown-toggle'
                                        type='button'
                                        data-toggle='dropdown'
                                      >
                                        Tutorials
                                        <span className='caret'></span>
                                      </a>
                                      <ul className='dropdown-menu'>
                                        <li>
                                          <a tabindex='-1' href='#'>
                                            HTML
                                          </a>
                                        </li>
                                        <li>
                                          <a tabindex='-1' href='#'>
                                            CSS
                                          </a>
                                        </li>
                                        <li className='dropdown-submenu'>
                                          <a
                                            className='test'
                                            tabindex='-1'
                                            href='#'
                                          >
                                            New dropdown{' '}
                                            <span className='caret'></span>
                                          </a>
                                          <ul className='dropdown-menu'>
                                            <li>
                                              <a tabindex='-1' href='#'>
                                                2nd level dropdown
                                              </a>
                                            </li>
                                            <li>
                                              <a tabindex='-1' href='#'>
                                                2nd level dropdown
                                              </a>
                                            </li>
                                            <li className='dropdown-submenu sublink'>
                                              <a className='sublink' href='#'>
                                                Another dropdown{' '}
                                                <span className='caret'></span>
                                              </a>
                                              <ul className='dropdown-menu'>
                                                <li>
                                                  <a href='#'>
                                                    3rd level dropdown
                                                  </a>
                                                </li>
                                                <li>
                                                  <a href='#'>
                                                    3rd level dropdown
                                                  </a>
                                                </li>
                                              </ul>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </li>
                                    <li>
                                      <a
                                        className='btn btn-default dropdown-toggle'
                                        type='button'
                                        data-toggle='dropdown'
                                      >
                                        Tutorials
                                        <span className='caret'></span>
                                      </a>
                                      <ul className='dropdown-menu'>
                                        <li>
                                          <a tabindex='-1' href='#'>
                                            HTML
                                          </a>
                                        </li>
                                        <li>
                                          <a tabindex='-1' href='#'>
                                            CSS
                                          </a>
                                        </li>
                                        <li className='dropdown-submenu'>
                                          <a
                                            className='test'
                                            tabindex='-1'
                                            href='#'
                                          >
                                            New dropdown{' '}
                                            <span className='caret'></span>
                                          </a>
                                          <ul className='dropdown-menu'>
                                            <li>
                                              <a tabindex='-1' href='#'>
                                                2nd level dropdown
                                              </a>
                                            </li>
                                            <li>
                                              <a tabindex='-1' href='#'>
                                                2nd level dropdown
                                              </a>
                                            </li>
                                            <li className='dropdown-submenu sublink'>
                                              <a className='sublink' href='#'>
                                                Another dropdown{' '}
                                                <span className='caret'></span>
                                              </a>
                                              <ul className='dropdown-menu'>
                                                <li>
                                                  <a href='#'>
                                                    3rd level dropdown
                                                  </a>
                                                </li>
                                                <li>
                                                  <a href='#'>
                                                    3rd level dropdown
                                                  </a>
                                                </li>
                                              </ul>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </li>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className='collapse navbar-collapse hidden-lg'
                        id='myNavbar'
                      >
                        <button
                          type='button'
                          className='navbar-toggle'
                          data-toggle='collapse'
                          data-target='#myNavbar'
                        >
                          x
                        </button>
                      </div>
                    </nav>
                  </li>

                  <li>
                    <a
                      href={`${process.env.REACT_APP_USHJA_APP}/login`}
                      target='_window'
                      className='yellowbg'
                    >
                      MEMBER ACCOUNT
                      <i className='fa fa-sign-out' aria-hidden='true'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div className='primaryheader nav-lg'>
          <NavBar />
        </div>
      </div>
      {/* <img src={SkinnyBanner_FaxNumber} className='respoimg' /> */}
      <img src={WCHR_WebsiteHeader_1} className='respoimg' />

      <Grid container direction='row' justify='center' alignItems='center'>
        <Hidden only='xs'>
          <Grid item md={3} spacing={3} className='hidden-xs'>
            <SideMenuDefault />
          </Grid>
          <Grid item md={9}>
            <React.Suspense fallback={'Loading'}>
              <Layout />
            </React.Suspense>
          </Grid>
        </Hidden>
        <Hidden only={['md', 'sm', 'lg', 'xl']}>
          <Grid item>
            <React.Suspense fallback={'Loading'}>
              <Layout />
            </React.Suspense>
          </Grid>
        </Hidden>

        {/* <Grid item md={3} spacing={3} className='hidden-xs'>
          <SideMenuStanding />
        </Grid>
        <Grid item md={9}>
          <React.Suspense fallback={'Loading'}>
            <Layout />
          </React.Suspense>
        </Grid> */}
      </Grid>
      <FooterComp />
    </div>
  );
}

export default App;
